import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { notificationListeners } from './pushNotifications';

/** Listens for push notifications, used on mobile app */
const AppUrlListener = () => {
    const navigate = useNavigate();
    useEffect(() => {
        notificationListeners(navigate);
    }, []);

    return null;
};

export default AppUrlListener;
